import { KonvaEventObject } from 'konva/lib/Node';
import { memo } from 'react';
import { Circle } from 'react-konva';
import { Point } from './types';
import { POLYGON_LINE_STROKE_COLOR } from './utils';

const MIDPOINT_HANDLE_RADIUS = 5;
const HANDLE_FILL = '#ffffff';

interface Props {
  position: Point;
  index: number;
  onDragStart: (e: KonvaEventObject<DragEvent>) => void;
  onDragMove: (e: KonvaEventObject<DragEvent>) => void;
  onDragEnd: (e: KonvaEventObject<DragEvent>) => void;
  onMouseEnter: (e: KonvaEventObject<MouseEvent>) => void;
  onMouseLeave: (e: KonvaEventObject<MouseEvent>) => void;
}

export const MidpointHandle = memo(function MidpointHandle({
  position,
  index,
  onDragStart,
  onDragMove,
  onDragEnd,
  onMouseEnter,
  onMouseLeave,
}: Props) {
  return (
    <Circle
      x={position.x}
      y={position.y}
      radius={MIDPOINT_HANDLE_RADIUS}
      fill={HANDLE_FILL}
      stroke={POLYGON_LINE_STROKE_COLOR}
      strokeWidth={1}
      draggable
      data-index={index}
      onDragStart={onDragStart}
      onDragMove={onDragMove}
      onDragEnd={onDragEnd}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  );
});
